var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.step.name))]),_c('div',[_c('div',{staticClass:"disable-caps"},[_vm._v(_vm._s(_vm.displayName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }